const ROLES = {
	super_admin: "SUPER ADMIN",
	admin: "ADMIN",
	employer: "EMPLOYER",
	employee: "EMPLOYEE",
	dependent: "DEPENDENT",
	provider: "PROVIDER"
};

export default ROLES;
